module.exports = "/fonts/nucleo-icons.eot?19abb5402a664606b14cb338e7fefd3b";